import React from 'react';
import { Box, Typography, Link, Container, Grid, Avatar } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#181818', color: 'white', py: 6 }}>
        <Container>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                    <Avatar src="/jsa_icon.png" alt="Logo" sx={{ width: 120, height: 120}}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                        JSA @ NCSU
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                        Links
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Link href="/home" color="inherit" underline="hover" sx={{ mb: 0.5 }}>
                        Home
                    </Link>
                    <Link href="/get-involved" color="inherit" underline="hover" sx={{ mb: 0.5 }}>
                        Get Involved
                    </Link>
                    <Link href="/executive-board" color="inherit" underline="hover" sx={{ mb: 0.5 }}>
                        Executive Board
                    </Link>
                    <Link href="/gallery" color="inherit" underline="hover" sx={{ mb: 0.5 }}>
                        Gallery
                    </Link>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                        Contact
                    </Typography>
                    <a href="mailto:ncstate.jsa@gmail.com" target='blank' style={{ textDecoration: "none", color: "inherit" }}>
                        <Typography variant="body2" color="white">
                            Email: ncstate.jsa@gmail.com
                        </Typography>
                    </a>
                    <a href="https://www.instagram.com/ncsujsa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target='blank' style={{ textDecoration: "none", color: "inherit" }}>
                        <Typography variant="body2" color="white">
                            Instagram: ncsujsa
                        </Typography>
                    </a>
                </Grid>
            </Grid>

            <Box sx={{ textAlign: 'center', mt: 4 }}>
                <Typography variant="body2" color="white">
                </Typography>
            </Box>
        </Container>
    </Box>
  );
};

export default Footer;
